module.exports = __webpack_public_path__ + "static/media/banner-login.d7f6e70e.jpg";